module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp123_7005.8dabea5c.png";